module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm0 15.71c3.623 0 7.07-.962 10-2.653C25.545 21.633 21.215 26 16 26S6.456 21.627 6 16.05c2.93 1.69 6.377 2.658 10 2.658zM8 11c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3zm12 0c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./icons/happy.svg
 ** module id = 10
 ** module chunks = 0
 **/